import { FC, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { Row, Col, Affix } from 'antd'; // Button List
import V2Tabs from '@/common/components/Data/V2Tabs';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
// import V2Anchor from '@/common/components/Others/V2Anchor';
import LocationMap from '../LocationMap';
import AddressClusterMap from './components/AddressClusterMap';
import FootprintDetail from './components/FootprintDetail';
import BusinessPlanningDetail from './components/BusinessPlanningDetail';
import BusinessInfoDetail from './components/BusinessInfoDetail';
import DailyFlowDetail from './components/DailyFlowDetail';
import { getPropertyItemMap, decodeTextValue, checkNumberInputIsRed, checkRadioIsRed, checkboxCheckIsRed } from './config';
import { ControlType, formDataComsToTiled, OTHER_TYPE_ID, parseValueCatch } from '@/common/components/business/DynamicComponent/config';
import { getBusinessTermsTypeName, isShowDiscount, isShowRent } from '@/common/components/business/DynamicComponent/components/BusinessTerms/config';
import { isArray, isNotEmpty, isNotEmptyAny } from '@lhb/func';
import styles from './index.module.less';
import cs from 'classnames';
import CustomizedOfAttachment from './components/CustomizedOfAttachment';
// import Surround from './components/Surround';
import ContendInfoDetail from './components/ContendInfoDetail';
import RefConversionDetail from './components/RefConversionDetail';
import BenchBrandsDetail from './components/BenchBrandsDetail';
import CalculationJNPDetail from './components/CalculationJNPDetail';
import EstimateSalesYHTDetail from './components/EstimateSalesYHTDetail';
import PopulationFlowYHTDetail from './components/PopulationFlowYHTDetail';
import EstimateSalesConclusionYHTDetail from './components/EstimateSalesConclusionYHTDetail';
import PassengerFlowCountingDetail from './components/PassengerFlowCountingDetail';
import CompetitiveConditionsDetail from './components/CompetitiveConditionsDetail';
import SubForm from './components/SubForm';
import FranchiseeCooperationProgressDetail from './components/FranchiseeCooperationProgressDetail';
import CompanyMemberDetail from './components/CompanyMemberDetail';
import AIPredictEntryRateDetail from './components/AIPredictEntryRateDetail';
import AreaProtectionDetail from './components/AreaProtectionDetail';
import { videoTypes } from '@/common/components/config-v2';
import RecommendChancePoint from './components/RecommendChancePoint';

// const { Link } = Anchor;

// const targetConfigType = [
//   ControlType.SINGLE_RADIO.value,
//   ControlType.CHECK_BOX.value,
//   ControlType.INPUT_NUMBER.value
// ];

// 附加tab
export interface AdditionalTabProps {
  name: string; // tab标题
  children: ReactNode; // tab下自定义组件
}

interface IProps {
  title: string;
  data: any;
  detailInfoConfig?: any; // 属性项
  anchorCustomStyle?: any; // 锚点样式
  isStandard?: boolean;// 是否为标准版本
  additionTabs?: AdditionalTabProps []; // 额外的tabs，显示在动态tabs后面
  isApproval?: boolean; // 是否是审批工作台加载的
  ignoreAttach?: boolean; // 是否忽略附件资料Tab，不需要附件资料Tab时设置true
  notUseTemplate?: boolean; // 是否不使用模板，而只是按动态类型格式返回数据。这种情况下item中一般只确保字段controlType,name,textValue有值
  isTopSticky?: boolean; // tabbar是否置顶
  setHintStr?: Function; // 是否显示页面提示语
  topRef?: any;
  container?: any;
  dynamicTabContentRefs?: any;
  dynamicTabActiveRef?: any; // 点击tab时实时获取active项
  dynamicTabsRef?: any; // 同步动态表单tabs的ref
  dynamicTabsActive?: string; // 同步动态表单tabActive的state
  setDynamicTabsActive?:any; // 同步动态表单tabActive的setState
  fixedHeight?: number;
  disabledArea?: boolean;
  /** 区域保护检测结果变更后，更新详情顶部操作 */
  onAreaProtectionCollisionChange?: (hasCollisionWithin200m: boolean | undefined) => void;
}

/** 动态表单详情 */
const DynamicDetail: FC<IProps> = ({
  data,
  title,
  isStandard = false,
  detailInfoConfig = { span: 12 },
  // anchorCustomStyle = {},
  additionTabs = [],
  isApproval = false,
  ignoreAttach = false,
  notUseTemplate = false,
  isTopSticky = true,
  setHintStr,
  container,
  dynamicTabContentRefs,
  dynamicTabActiveRef,
  dynamicTabsRef,
  dynamicTabsActive,
  setDynamicTabsActive,
  fixedHeight,
  disabledArea,
  onAreaProtectionCollisionChange,
}) => {
  const dynamicDetail:any = useRef(null);
  // const dynamicTabContentRefs: any = useRef([]);
  const [tabActive, setTabActive] = useState<string>(''); // 当前tab值
  const propertyGroupVOList =
  data?.templateDetailResponse?.propertyGroupVOList ||
  data?.infoModule?.propertyGroupVOList || data; // 标准版本机会点详情获取数据结构
  // console.log('🚀 ~ file: index.tsx:24 ~ propertyGroupVOList:', propertyGroupVOList);
  //   字段列表，增加是否显示字段
  const fieldList = useMemo(() => getPropertyItemMap(propertyGroupVOList), [propertyGroupVOList]);

  /**
   * @description 所有属性组件
   * @return
   */
  const allComponents = useMemo(() => {
    if (!isArray(propertyGroupVOList)) {
      return null;
    }
    const allComps: any = [];
    formDataComsToTiled(propertyGroupVOList, allComps); // 将组件对象平铺到数组中
    return allComps;
  }, [propertyGroupVOList]);

  // 不同类型字段
  const FieldItem = ({ item }) => {
    const textValue = decodeTextValue(item?.controlType, item?.textValue);
    const name = item.anotherName || item.name;
    // 详情页目前用不到restriction
    const { templateRestriction } = item;
    let templateRestrictionVal: any = {};
    if (templateRestriction) {
      templateRestrictionVal = parseValueCatch(item, 'templateRestriction');
    }
    const { redMark } = templateRestrictionVal;
    const hintStr = data?.infoModule?.hint; // 页面提示语
    // 是否是换行显示
    const { nextLine } = templateRestrictionVal;
    const { controlType } = item;
    let colorVal = '';
    switch (controlType) {
      // 文件类
      case ControlType.UPLOAD.value:
        // 判断是否全是图片
        const PICTURE_REG = /(\.gif|\.jpeg|\.png|\.jpg|\.bmp|\.svg)$/; // 验证文件是图片格式的正则
        const VIDEO_REG = new RegExp(`(${videoTypes.map(t => `\\.${t}`).join('|')})$`);
        const isAllImage = textValue?.every((file) => PICTURE_REG.test(file.name));
        const isAllVideo = textValue?.every((file) => VIDEO_REG.test(file.name));
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            {isAllImage ? (
              <V2DetailItem label={name} type='images' assets={textValue.filter((item) => !!item.url)}/>
            ) : (
              isAllVideo ? (
                <V2DetailItem label={name} type='videos' assets={textValue.filter((item) => !!item.url)}/>
              ) : (
                <V2DetailItem label={name} type='files' assets={textValue.filter((item) => !!item.url)}/>
              )
            )}
          </Col>
        </>);
      // 地图类
      case ControlType.ADDRESS.value:
        /*
          textValue 数据例
          {"address":"浙江省杭州市拱墅区上塘街道上塘高架水晶城购物中心","longitude":120.151309,"latitude":30.303581,"poiId":null,"poiName":"浙江省杭州市拱墅区上塘街道上塘高架水晶城购物中心","isCluster":true}
          详情页回显时isCluster为true则显示为带经纬度和选址地图商圈信息的样式
        */
        return (
          textValue?.isCluster ? <>
            <Col span={24}></Col>
            <Col {...detailInfoConfig}>
              <V2DetailItem label={name} value={textValue?.address} />
            </Col>
            <Col {...detailInfoConfig}>
              <V2DetailItem label='经纬度' value={isNotEmpty(textValue.lng) && isNotEmpty(textValue.lat) ? `${textValue.lng},${textValue.lat}` : '-'} />
            </Col>
            <Col span={24}>
              <V2DetailItem>
                <AddressClusterMap
                  lng={textValue?.lng}
                  lat={textValue?.lat}
                  allComponents={allComponents}
                />
              </V2DetailItem>
            </Col>
          </> : <>
            <Col span={24}></Col>
            <Col span={24}>
              <V2DetailItem label={name} value={textValue?.address} />
            </Col>
            <Col span={24}>
              <V2DetailItem>
                <LocationMap lng={textValue?.lng} lat={textValue?.lat} />
              </V2DetailItem>
            </Col>
          </>
        );
      // 省市区
      case ControlType.AREA.value:
      case ControlType.CUSTOM_AREA.value: // 独立的省市区（不关联商圈）
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem label={name}
              value={(Array.isArray(textValue) ? textValue : []).reduce((acc, item) => {
                // 省市区中文去重
                return acc.includes(item.name) ? acc : acc.concat(item.name);
              }, []).join('') || ''}
            />
          </Col>
        </>);
      // 数字，带后缀
      case ControlType.INPUT_NUMBER.value:
        colorVal = checkNumberInputIsRed(templateRestrictionVal, textValue?.value) ? '#f23030' : '';
        colorVal && redMark?.isPageTip && setHintStr && hintStr && setHintStr(hintStr);
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem
              labelStyle={{
                color: colorVal
              }}
              valueStyle={{
                color: colorVal
              }}
              label={name}
              verticalMiddleHelp={<>
                {
                  colorVal && redMark?.isItemTip && redMark?.itemTip ? <div className='c-f23 fs-12'>{redMark?.itemTip}</div> : null
                }
              </>}
              value={`${isNotEmpty(textValue?.value) ? textValue?.value : '-'}${textValue?.suffix || ''}`}/>
          </Col>
        </>);
      case ControlType.LEASE_TERM.value:
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem
              label={name}
              value={textValue?.startDate && textValue?.endDate ? `${textValue.startDate} 至 ${textValue.endDate}` : ''}/>
          </Col>
          <Col {...detailInfoConfig}>
            <V2DetailItem label='租期时长' value={textValue?.duration}/>
          </Col>
        </>);
      case ControlType.PROJECT_SPOT_SELECT.value:
        return (<>
          {nextLine ? <Col span={24}></Col> : null}
          <Col {...detailInfoConfig}><V2DetailItem label='项目名称' value={textValue?.projectName || '-'} /></Col>
          <Col {...detailInfoConfig}><V2DetailItem label='点位名称' value={textValue?.spotName || '-'} /></Col>
        </>);
      case ControlType.BUSINESS_CONDITION.value: {
        /*
          textValue 数据例
          { type: 1, rent: 1275, discount: null }
          「两者取高」只展示月租金与扣点比例两个值，不做 Max 计算
        */
        const type = textValue?.type;
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem label='计费方式' value={getBusinessTermsTypeName(type) || '-'}/>
          </Col>
          {
            isShowRent(type) ? <Col {...detailInfoConfig}>
              <V2DetailItem label='月租金' value={isNotEmpty(textValue?.rent) ? `${textValue.rent}元/月` : '-'}/>
            </Col> : null
          }
          {
            isShowDiscount(type) ? <Col {...detailInfoConfig}>
              <V2DetailItem label='扣点比例' value={isNotEmpty(textValue?.discount) ? `${textValue.discount}%` : '-'}/>
            </Col> : null
          }
        </>);
      }
      // 单选
      case ControlType.SINGLE_RADIO.value:
        const targetOption = checkRadioIsRed(templateRestrictionVal, textValue?.id);
        // 注意这里有坑，decodeTextValue中把selectedId转成了id
        colorVal = targetOption ? '#f23030' : '';
        colorVal && targetOption?.isPageTip && setHintStr && hintStr && setHintStr(hintStr);
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem
              labelStyle={{
                color: colorVal
              }}
              valueStyle={{
                color: colorVal
              }}
              verticalMiddleHelp={<>
                {
                  colorVal && targetOption?.isItemTip && targetOption?.itemTip ? <div className='c-f23 fs-12'>{targetOption?.itemTip}</div> : null
                }
              </>}
              label={name}
              value={
                textValue?.id === OTHER_TYPE_ID
                  ? `${textValue.name}(${textValue?.input})`
                  : textValue?.name
              }/>
          </Col>
        </>);
      // 多选
      case ControlType.CHECK_BOX.value:
        const targetOptions: any[] = checkboxCheckIsRed(templateRestrictionVal, textValue);
        const targetStr = targetOptions?.reduce((acc, cur, curIndex) => {
          const { isRedMark, isItemTip, itemTip } = cur;
          if (isRedMark && isItemTip && itemTip) return `${acc}${itemTip || ''}${curIndex < (targetOptions.length - 1) ? '、' : ''}`;
          return '';
        }, '');
        // 注意这里有坑，decodeTextValue中把textValue中的selectedId转成了id
        colorVal = isArray(targetOptions) && targetOptions.length > 0 ? '#f23030' : '';
        const targetIsPageTip = targetOptions?.find((item) => item.isPageTip);
        colorVal && !!targetIsPageTip && setHintStr && hintStr && setHintStr(hintStr);
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem
              labelStyle={{
                color: colorVal
              }}
              valueStyle={{
                color: colorVal
              }}
              verticalMiddleHelp={<>
                {
                  targetStr ? <div className='c-f23 fs-12'>{targetStr}</div> : null
                }
              </>}
              label={name}
              value={textValue?.map((value) => value?.id === OTHER_TYPE_ID
                ? `${value.name}(${value?.input})`
                : value?.name).join('、')}/>
          </Col>
        </>);
      case ControlType.TEXT_AREA.value:
        // 多行文本类
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem label={name} value={textValue} type='textarea' />
          </Col>
        </>);
      case ControlType.SUB_FORM.value:
        return (
          <Col span={24}>
            <SubForm label={name} value={textValue} configList={item.formConfigList} hintStr={hintStr} setHintStr={setHintStr} detailInfoConfig={detailInfoConfig}/>
          </Col>
        );
      case ControlType.SURROUND_SEARCH.value:
        const value = JSON.parse(textValue);
        if (value === null) {
          return <></>;
        }
        // 周边查询
        return (<>
          <Col span={24}></Col>
          <Col span={24}>
            <V2DetailItem label={name} value={value?.address} />
          </Col>
          <Col span={24}>
            <V2DetailItem>
              <LocationMap lng={value?.lng} lat={value?.lat} />
            </V2DetailItem>
          </Col>
          {isArray(value?.surround) && value?.surround?.length &&
          value?.surround?.map((item, idx) => (
            <Col key={idx} span={12}>
              <V2DetailItem label={item?.categoryName} value={item?.text} />
            </Col>
          ))}
          <Col span={24}></Col>
        </>
        );
      case ControlType.FOOTPRINT.value:// 踩点设置
        const fpValue = JSON.parse(textValue);
        if (fpValue === null) {
          return <></>;
        }
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <FootprintDetail info={fpValue} />
        </>);
      case ControlType.CONTEND_INFO.value: {
        // 店铺周边竞品
        const _textValue = JSON.parse(textValue);
        if (_textValue === null) {
          return <></>;
        }
        return (<>
          {!!nextLine && <Col span={24}></Col>}
          <Col span={24}>
            <ContendInfoDetail value={_textValue} />
          </Col>
        </>);
      }
      case ControlType.COMPETITIVE_CONDITIONS.value: {
        // 竞争条件
        const _textValue = JSON.parse(textValue);
        if (_textValue === null) {
          return <></>;
        }
        return (<>
          {!!nextLine && <Col span={24}></Col>}
          <Col span={24}>
            <CompetitiveConditionsDetail value={_textValue} />
          </Col>
        </>);
      }
      case ControlType.BUSINESS_PLANNING.value: // 商圈规划
        const bpValue = JSON.parse(textValue);
        if (bpValue === null) {
          return <></>;
        }
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col span={24}>
            <BusinessPlanningDetail info={bpValue} />
          </Col>
        </>);
      // 销售额预测
      case ControlType.SALE_AMOUNT.value:
        const saleValue = JSON.parse(textValue);
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col span={12}>
            <V2DetailItem label={name} value={saleValue?.saleAmount} />
          </Col>
        </>);
      case ControlType.MATCH_BUSINESS_CIRCLE.value: // 商圈信息
      {
        const bpValue = JSON.parse(textValue);
        if (bpValue === null) {
          return <></>;
        }
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col span={24}>
            <BusinessInfoDetail propertyItem={item} info={bpValue} disabledArea={disabledArea} />
          </Col>
        </>);
      }
      case ControlType.DAILY_FLOW_PREDICT.value:
      {
        const info = JSON.parse(textValue);
        // 日均客流预测
        return (
          <DailyFlowDetail info={info} />
        );
      }
      // 参考转化率、参考租金等查看文件的类型
      case ControlType.REFERENCE_CONVERSION.value:
      case ControlType.REFERENCE_RENT.value:
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <RefConversionDetail label={name} propertyItem={item}/>
          </Col>
        </>);
      case ControlType.BENCH_MARKING_BRANDS.value:
      {
        const brandsInfo = JSON.parse(textValue);
        if (brandsInfo === null) {
          return <></>;
        }
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col span={24}>
            <BenchBrandsDetail value={brandsInfo} />
          </Col>
        </>);
      }
      case ControlType.PROFIT_CAlCULATION_JNP.value:
      {
        const objVal = JSON.parse(textValue);
        if (objVal === null) {
          return <></>;
        }
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col span={24}>
            <CalculationJNPDetail value={objVal} />
          </Col>
        </>);
      }
      case ControlType.ESTIMATE_SALES_KWK.value:
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem
              label={name}
              value={`${isNotEmpty(textValue) ? `${textValue} 元` : '-'}`}
            />
          </Col>
        </>);
      case ControlType.ESTIMATE_SALES_YHT.value:
        return <EstimateSalesYHTDetail textValue={textValue}/>;
      case ControlType.POPULATION_FLOW_YHT.value:
        return <PopulationFlowYHTDetail propertyItem={item} textValue={textValue}/>;
      case ControlType.ESTIMATE_SALES_CONCLUSION_YHT.value:
        return <EstimateSalesConclusionYHTDetail textValue={textValue}/>;
      // 客流计数
      case ControlType.PASSENGER_FLOW.value:
        return <PassengerFlowCountingDetail textValue={textValue}/>;
      // 加盟商合作进展（一鸣）
      case ControlType.FRANCHISEE_COOPERATION_PROGRESS.value:
        return <FranchiseeCooperationProgressDetail textValue={textValue}/>;
      // 公司成员
      case ControlType.COMPANY_MEMBER.value:
        return <CompanyMemberDetail label={name} textValue={textValue} detailInfoConfig={detailInfoConfig} />;
      // 预测入口率
      case ControlType.AI_PREDICT_ENTRY_RATE.value:
        return <AIPredictEntryRateDetail label={name} textValue={textValue} />;
      case ControlType.AREA_PROTECTION.value:
        return <AreaProtectionDetail textValue={textValue} allComponents={allComponents} chancePointId={data?.id ?? null} onCollisionChange={onAreaProtectionCollisionChange} />;
      // 关联踩点记录仅在机会点创建/编辑态展示
      case ControlType.ASSOCIATED_RECORDS.value:
        return <></>;
      // 推荐机会点
      case ControlType.RECOMMEND_CHANCE_POINT.value:
        return <Col span={24}>
          <RecommendChancePoint
            titleText={item.anotherName || item.name || '推荐机会点'}
            franchiseeId={data?.id}
          />
        </Col>;
      default:
        // 文本类
        return (<>
          {
            nextLine ? <Col span={24}></Col> : null
          }
          <Col {...detailInfoConfig}>
            <V2DetailItem label={name} value={textValue} />
          </Col>
        </>);
    }
  };

  const tabChange = (active: string) => {
    setTabActive(active);
    setDynamicTabsActive && setDynamicTabsActive(active);
    dynamicTabActiveRef && (dynamicTabActiveRef.current = active);
    if (dynamicTabContentRefs) {
      const targetEle = dynamicTabContentRefs.current?.find((refItem) => refItem.key === active);
      const topVal = (targetEle?.el?.offsetTop || 0) + (dynamicDetail.current?.offsetTop || 0);
      container?.current?.scrollTo({
        top: (topVal - ((fixedHeight || 0))), // 减去的24是容器的margin-top
        behavior: 'smooth'
      });

      // 之前的scrollTo没生效，使用scrollIntoView
      // targetEle.el.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  };

  const getTabContentRefs = (el: any, index: number, key: string) => {
    if (!dynamicTabContentRefs?.current) return;
    dynamicTabContentRefs.current[index] = {
      el,
      key
    };
  };

  /**
   * @description 是否展示该第一级tab
   * @param fieldList 所有属性的值对象，不分等级，平铺到对象
   * @param firstLevel 以及数据
   * @return 是否展示
   */
  const isShowFirstLevel = (fieldList, firstLevel) => {
    return Array.isArray(firstLevel?.childList) &&
    firstLevel?.childList.length > 0 &&
    firstLevel?.childList.some(secondLevel => isShowSecondLevel(fieldList, secondLevel));
  };

  /**
   * @description 是否展示该第二级组
   * @param fieldList 所有属性的值对象，不分等级，平铺到对象
   * @param secondLevel 二级数据
   * @return 是否展示
   */
  const isShowSecondLevel = (fieldList, secondLevel) => {
    return Array.isArray(secondLevel?.propertyConfigVOList) &&
    secondLevel?.propertyConfigVOList.length > 0 &&
    (notUseTemplate || secondLevel.propertyConfigVOList.some(field => !!fieldList[field.propertyId].isShow));
  };

  /**
   * @description 是否展示propertyList的二级标题
   * @param secondLevel 二级数据
   * @return 是否展示，默认true展示，如果第一项property是本身就带有小标题的特定组件就返回false不展示
   */
  const showSecondLevelTitle = (fieldList, secondLevel: any) => {
    const properties = isArray(secondLevel?.propertyConfigVOList) ? (notUseTemplate ? secondLevel.propertyConfigVOList : secondLevel.propertyConfigVOList.filter(field => !!fieldList[field.propertyId].isShow)) : [];

    const firstItem = properties.length ? properties[0] : null;
    // 基诺浦组件本身有小标题，处于第一个字段时不展示二级标题，否则会出现连续展示两个标题的问题

    // 匹配商圈有值时，展示的区域信息，或者周边测评信息，都是自带小标题，不展示二级标题，否则会出现连续展示两个标题的问题
    if (firstItem?.controlType === ControlType.MATCH_BUSINESS_CIRCLE.value) {
      /*
        匹配商圈组件的值
        未选地址时，textValue为null
        选地址不在区域内，textValue: "{\"lat\":30.283756,\"lng\":120.157653}"
        选地址在区域内，textValue: {"isInCluster":true,"clusterId":1052877,"planClusterId":null,"clusterName":"合肥凤凰文化广场","clusterTypeName":"商业区/商业体","clusterScore":"85.6","planStores":null,"openStores":0,"distance":20.57915686827509,"planSpots":null,"lat":31.809016,"lng":117.286636}
      */
      const valObj = JSON.parse(firstItem.textValue);
      const hasSelfTitle = typeof valObj === 'object' && isNotEmptyAny(valObj);
      return !hasSelfTitle;
    }

    const hide = firstItem?.controlType === ControlType.PROFIT_CAlCULATION_JNP.value;
    return !hide;
  };

  const tabs = useMemo(() => {
    const items: any = [];

    if (Array.isArray(propertyGroupVOList)) {
      propertyGroupVOList.filter((tab) => isShowFirstLevel(fieldList, tab)).forEach((tab, index) => {
        // 渲染一个动态tab
        // const anchorItems = Array.isArray(tab.childList) ? tab.childList.map((item: any) => ({
        //   id: `title${item.id}`,
        //   title: item.name,
        // })) : [];

        const children = Array.isArray(tab.childList)
          ? (<div /* className='dynamicComCon'*/>
            {
              tab.childList.map((item, itemIndex) => {
                return (
                  <div key={item.name + itemIndex}>
                    {isShowSecondLevel(fieldList, item) && showSecondLevelTitle(fieldList, item) && <V2Title
                      // id={anchorItems[itemIndex].id}
                      type='H2'
                      divider
                      text={item.name}
                      // tab数为1且是tab下第一个组时 不需要margin-top
                      className={(propertyGroupVOList.length > 1 || itemIndex) && 'mt-24'}/>}
                    {/* 字段遍历 */}
                    <Row gutter={24}>
                      {Array.isArray(item.propertyConfigVOList) && item.propertyConfigVOList.map((field, fieldIndex) => {
                        if (notUseTemplate) {
                          return <FieldItem item={field} key={field.name + fieldIndex} />;
                        } else {
                          return fieldList[field.propertyId].isShow && (
                            <FieldItem item={field} key={field.name + fieldIndex} />
                          );
                        }
                      })}
                    </Row>
                  </div>
                );
              })
            }
            {/* <V2Anchor
              getContainer={() => {
                const target:any = dynamicDetail.current || document.body;
                return target;
              }}
              className={
                cs(styles.anchorCon,
                  anchorItems.length > 1 ? '' : 'hide',
                  isNotEmptyAny(anchorCustomStyle) ? '' : styles.defaultPostion)}
              style={
                isNotEmptyAny(anchorCustomStyle) ? anchorCustomStyle : {}
              }
            >
              { anchorItems.map(item => <Link
                key={item.id}
                href={`#${item.id}`}
                title={item.title}
              />) }
            </V2Anchor> */}
          </div>) : <></>;

        items.push({
          label: tab.name,
          key: tab.name + index,
          child: children
        });
      });
    }

    if (Array.isArray(additionTabs)) {
      // 渲染一个额外tab
      additionTabs.forEach((tab, index) => {
        items.push({
          label: tab.name,
          key: tab.name + index,
          child: tab.children
        });
      });
    }
    // 0707版本 https://confluence.lanhanba.com/pages/viewpage.action?pageId=67533495 十一： 快速生成三张截图 ，需要添加一个写死的Tab
    // 0727 标准版本拓店不需要渲染【附件资料】tab项
    !ignoreAttach && items.push({
      label: '附件资料',
      key: 'customizedOfAttachment',
      child: <CustomizedOfAttachment
        detail={data}
        isApproval={isApproval}
        isStandard={isStandard}
      />
    });
    return items;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyGroupVOList]);

  /**
   * @description tabs变动时，设置默认选中tab
   */
  useEffect(() => {
    dynamicTabsRef && (dynamicTabsRef.current = tabs);
    if (Array.isArray(additionTabs) && additionTabs.length) {
      // 有附加tab，定位到最后一个tab
      // setTabActive(tabs[tabs.length - 1].key);
      // 0707 末尾新增了一个写死的Tab，故这里需要减2
      const active = ignoreAttach ? tabs.length - 1 : tabs.length - 2;
      setTabActive(tabs[active].key);
      return;
    }
    if (Array.isArray(tabs) && tabs.length) {
      // 有tab，定位到第一个tab
      setTabActive(tabs[0].key);
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs]);
  // 父容器滚动到对应位置时设置tabs选中项
  useEffect(() => {
    if (!dynamicTabsActive) return;
    setTabActive(dynamicTabsActive);
  }, [dynamicTabsActive]);

  return (
    <div
      ref={dynamicDetail}
      className={
        cs(styles.dynamicDetail,
          isTopSticky && styles.topSticky,
          // 只有一个tab的时候隐藏tab项 //TODO: 顶部遮挡
          propertyGroupVOList && propertyGroupVOList.length === 1 && styles.hideTab)
      }>
      {title && (
        <div className={styles.topCon}>
          <div className={styles.topTitle}>{title}</div>
        </div>
      )}

      {Array.isArray(tabs) && !!tabs.length ? <>
        <Affix
          offsetTop={0}
          target={() => container?.current}
        >
          <V2Tabs
            items={tabs}
            activeKey={tabActive}
            onChange={tabChange}
          />
        </Affix>
        {/* Tab content 内容 */}
        {
          tabs.map((tabItem: any, index: number) => <div
            ref={(el) => getTabContentRefs(el, index, tabItem.key)}
            key={index}
          >
            {tabItem.child}
          </div>)
        }
      </> : <></>
      }
    </div>
  );
};

export default DynamicDetail;
